import { isMainThread } from "../env.ts";
function parallel(module) {
    void module;
    throw new Error("Unsupported runtime");
}
(function (parallel) {
    parallel.maxWorkers = undefined;
    parallel.workerEntry = undefined;
    parallel.isMainThread = false;
})(parallel || (parallel = {}));
Object.defineProperty(parallel, "isMainThread", {
    value: isMainThread,
    writable: false,
});
export default parallel;
//# sourceMappingURL=parallel.js.map